import type { ImageInput, MrzScannerConfiguration, MrzScannerScreenConfiguration, ResultWrapper } from '../types';
import { MrzScannerResult, MrzScannerUiResult, handleImageInput, mapRTUUIResult, withSBErrorHandling } from '../types';

import { ScanbotSDKPlugin } from './Definitions';

/**
 * @internal
 * @hidden
 */
export const ScanbotMrzImpl = {
  async scanFromImage(params: {
    image: ImageInput;
    configuration: MrzScannerConfiguration;
  }): Promise<MrzScannerResult> {
    return withSBErrorHandling(
      async () =>
        new MrzScannerResult(
          await ScanbotSDKPlugin.scanMrzFromImage({
            configuration: params.configuration,
            image: handleImageInput(params.image),
          }),
        ),
    );
  },

  async startScanner(configuration: MrzScannerScreenConfiguration): Promise<ResultWrapper<MrzScannerUiResult>> {
    return withSBErrorHandling(async () =>
      mapRTUUIResult<MrzScannerUiResult>(await ScanbotSDKPlugin.startMrzScanner(configuration), MrzScannerUiResult),
    );
  },
};
